import { render } from "./QuizIndex.vue?vue&type=template&id=b7071f00"
import script from "./QuizIndex.vue?vue&type=script&lang=js"
export * from "./QuizIndex.vue?vue&type=script&lang=js"

import "./QuizIndex.vue?vue&type=style&index=0&id=b7071f00&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__